export const AUTH_CONFIG = {
  enableEmailLogin: false,
  enableMobileOtp: true, // turn true after DLT approval
  enableRegister: false,
  defaultMode: "mobile", // "email" | "mobile"
};